 <!-- page starts-->
<section class="page-wrapper">
    <div class="ashton-hero-top-detail-payment-done cf">
      	<div class="container">
      		<div class="ashton-hero-top-payment-done-section cf">
      			<div class="ashton-hero-top-payment-done-detail">
	      			<h2>Booking Successful!</h2>
	      			<div class="ashton-hero-top-payment-done-box cf">
		      			<div class="ashton-hero-top-payment-done-left">
		      				<div class="ashton-hero-top-payment-done-left-image">
		      					<img src="assets/images/avoid-image.png">
		      				</div>
		      				<h3>Payment Done</h3>
		      			</div>
		      			<div class="ashton-hero-top-payment-done-right">
		      				<div class="ashton-hero-top-payment-done-right-content">
			      				<h3>Ashton United Vs Radcliffe Borough</h3>
			      				<p>Tuesday, 8 September 2020 19:45</p>
			      			</div>
		      				<div class="ashton-hero-top-payment-done-right-btn">
		      					<a href="javascript:void(0);">View Details</a>
		      				</div>
		      			</div>
		      		</div>
		      	</div>
      		</div>
      	</div>
    </div>
</section><!-- page ends-->